<template>
  <a
    href="javascript:void(0);"
    class="trans"
    :class="{ active: isActive, 'tab-disabled': disabled }"
    @click="clickHandler"
  >
    <slot name="label">{{ label }}</slot>
  </a>
</template>

<script setup>
import { inject, computed, watchEffect } from "vue";

// Define component name
defineOptions({
  name: "sakura-tab",
});

const props = defineProps({
  label: String,
  name: String,
  disabled: Boolean,
});

const tabs = inject("tabs");

const isActive = computed(() => {
  return tabs?.modelValue?.value === props.name;
});

const clickHandler = () => {
  if (!props.disabled) {
    tabs?.handleTabClick(props.name);
  }
};

// Force update when `label` changes (Vue 3 does not have `$forceUpdate`)
watchEffect(() => {
  tabs?.update?.();
});
</script>

<style scoped>
/* Add your styles here */
</style>
